import { __extends, __assign, __makeTemplateObject, __spreadArray } from 'tslib';
import React, { Fragment, useState, useEffect, Component } from 'react';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { IconExternal, SvgProvider } from '@next-common/shared-svg';
import { LinkOrSpan, LinkOrSpanContext, HideInWebviewHoc, HideInWebview, Hyperlink } from '@next-common/shared-component';
import { configService } from '@next-common/config-service';
import { useBreakpoint, BreakpointProvider } from '@next-common/breakpoint';
import { makeStyles } from '@material-ui/core/styles';
import { colorPalette } from '@next-common/material-ui';

var FooterIcon = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, iconUri = _a.iconUri;
    if (iconUri) {
        return React.createElement(IconExternal, { iconUri: iconUri, className: className, width: width, height: height });
    }
    return null;
};

var t = {"text":"_f-text","helper_hide-AboveTablet":"_f-helper_hide-AboveTablet","sr-only":"_f-sr-only","contain":"_f-contain","br":"_f-br","db":"_f-db","dib":"_f-dib","dn-ns":"_f-dn-ns","flex":"_f-flex","flex-column":"_f-flex-column","flex-wrap":"_f-flex-wrap","items-center":"_f-items-center","justify-between":"_f-justify-between","justify-around":"_f-justify-around","fr":"_f-fr","i":"_f-i","normal":"_f-normal","b":"_f-b","h-auto":"_f-h-auto","link":"_f-link","list":"_f-list","mw-none":"_f-mw-none","w-100":"_f-w-100","w-auto":"_f-w-auto","overflow-hidden":"_f-overflow-hidden","static":"_f-static","relative":"_f-relative","dark-gray":"_f-dark-gray","gray":"_f-gray","bg-near-white":"_f-bg-near-white","bg-white":"_f-bg-white","pa0":"_f-pa0","pa1":"_f-pa1","pa3":"_f-pa3","pl4":"_f-pl4","pr4":"_f-pr4","pb4":"_f-pb4","pt2":"_f-pt2","pv3":"_f-pv3","ph4":"_f-ph4","ma0":"_f-ma0","collapse":"_f-collapse","no-underline":"_f-no-underline","tc":"_f-tc","f6":"_f-f6","center":"_f-center","pointer":"_f-pointer","f12":"_f-f12","pa-8":"_f-pa-8","rcToolTipZoomIn":"_f-rcToolTipZoomIn","rcToolTipZoomOut":"_f-rcToolTipZoomOut","lds-dual-ring":"_f-lds-dual-ring"};

var s$c = {"reinsuranceBlock":"_f-reinsuranceBlock-a342e0","icon":"_f-icon-f0cd2a","a":"_f-a-5601a8","iconPriceClub":"_f-iconPriceClub-68ccaa","labels":"_f-labels-2c7f3c","labelSmall":"_f-labelSmall-13b533","labelLarge":"_f-labelLarge-bdffe0"};

var LinkContent$3 = function (_a) {
    var _b, _c;
    var item = _a.item;
    return (React.createElement(Fragment, null,
        React.createElement(FooterIcon, { className: "".concat(s$c.icon, " ").concat(item.id === 1 && s$c.iconPriceClub), iconUri: item.icon, width: item.width, height: item.height }),
        React.createElement("div", { className: "".concat(s$c.labels, " ").concat(t.flex, " ").concat(t['flex-column']) },
            React.createElement("span", { className: "".concat(t['dark-gray'], " ").concat(s$c.labelSmall) }, (_b = item.labels) === null || _b === void 0 ? void 0 : _b.small),
            React.createElement("span", { className: "".concat(t.gray, " ").concat(s$c.labelLarge) }, (_c = item.labels) === null || _c === void 0 ? void 0 : _c.large))));
};
var Reinsurance = function (_a) {
    var links = _a.links;
    return (React.createElement("div", { className: "".concat(t.flex, " ").concat(t.pa3, " ").concat(t['bg-white'], " ").concat(s$c.reinsuranceBlock) }, links.map(function (item) { return (React.createElement(LinkOrSpan, { key: item.id, href: item.link, className: "".concat(t.flex, " ").concat(t['no-underline'], " ").concat(s$c.a) },
        React.createElement(LinkContent$3, { item: item }))); })));
};

var s$b = {"socialIcons":"_f-socialIcons-7efa81","socialIconsSpace":"_f-socialIconsSpace-4a9392","iconSeparator":"_f-iconSeparator-7a054c"};

var LinkContent$2 = function (_a) {
    var item = _a.item;
    return (React.createElement(Fragment, null,
        React.createElement(FooterIcon, { className: "".concat(s$b.socialIcons, " ").concat(t.db, " ").concat(t['overflow-hidden']), iconUri: item.icon, width: item.width, height: item.height }),
        React.createElement("span", { className: "".concat(t['sr-only']) }, item.label)));
};
var SocialLinks = function (_a) {
    var links = _a.links;
    return (React.createElement("div", { className: "".concat(s$b.socialIconsSpace, " ").concat(s$b.iconSeparator, " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['bg-white'], " ").concat(t.pv3, " ").concat(t.ph4) }, links.map(function (item) {
        return (React.createElement(LinkOrSpan, { key: item.id, href: item.link, rel: "noopener noreferrer nofollow", target: "_blank" },
            React.createElement(LinkContent$2, { item: item })));
    })));
};

var s$a = {"appsLinksContainer":"_f-appsLinksContainer-392542","appsLinkPicContainer":"_f-appsLinkPicContainer-6b8253","osIsAndroid":"_f-osIsAndroid-75194f","isForIos":"_f-isForIos-7c7161","osIsIos":"_f-osIsIos-936007","isForAndroid":"_f-isForAndroid-99610f","appsLink":"_f-appsLink-4f6591","appsButton":"_f-appsButton-8e25c4"};

/* eslint-disable react/destructuring-assignment */
var getClass = function (mobileDetect) {
    if (mobileDetect && mobileDetect.android) {
        return s$a.osIsAndroid;
    }
    if (mobileDetect && mobileDetect.ios) {
        return s$a.osIsIos;
    }
    return "";
};
var LinkContent$1 = function (_a) {
    var item = _a.item;
    return (React.createElement(Fragment, null,
        React.createElement(FooterIcon, { className: "".concat(t.link, " ").concat(t['dark-gray'], " ").concat(s$a.appsButton), iconUri: item.icon, width: item.width, height: item.height }),
        React.createElement("span", { className: "".concat(t['sr-only']) }, item.label)));
};
// comment the following react component
var AppsLinks = function (props) {
    var label = props.label, link = props.link, links = props.links, mobileDetect = props.mobileDetect;
    var _a = useState(''), oSClass = _a[0], setOsClass = _a[1];
    // move the logic decision based on mobileDetect to the browser runtime, have the same server markup
    useEffect(function () {
        setOsClass(getClass(mobileDetect));
    });
    return (React.createElement("div", { className: " ".concat(s$a.appsLinksContainer, " ").concat(oSClass) },
        React.createElement(LinkOrSpan, { href: link, className: " ".concat(t.link, " ").concat(t['dark-gray'], " ").concat(s$a.appsLink, " ") }, label),
        React.createElement("div", { className: "".concat(t.flex, " ").concat(s$a.appsLinkPicContainer) }, links.map(function (item) { return (React.createElement(LinkOrSpan, { key: "appsLinks-".concat(item.icon || item.id), href: item.link, className: "".concat(item.os === 'android' ? s$a.isForAndroid : s$a.isForIos) },
            React.createElement(LinkContent$1, { item: item }))); }))));
};

var s$9 = {"img":"_f-img-e4055c"};

var LinkContent = function (_a) {
    var rakutenLogo = _a.rakutenLogo;
    return (React.createElement("img", { className: "".concat(t.db, " ").concat(t['mw-none'], " ").concat(s$9.img), src: rakutenLogo.img, 
        // @ts-expect-error can be null
        alt: /[^/]+$/.exec(rakutenLogo.img)[0] }));
};
var RakutenGroupLinksLogo = function (_a) {
    var rakutenLogo = _a.rakutenLogo;
    return (React.createElement(LinkOrSpan, { target: "_blank", rel: "noopener noreferrer", href: rakutenLogo.link },
        React.createElement(LinkContent, { rakutenLogo: rakutenLogo })));
};

var s$8 = {"anchor":"_f-anchor-21f9b3","viki":"_f-viki-35bac0","companies":"_f-companies-871726","list":"_f-list-23f0f4"};

var RakutenGroupLinksCompanies = function (_a) {
    var companies = _a.companies;
    return (React.createElement("ul", { className: "".concat(t.list, " ").concat(t.ma0, " ").concat(t.pa0, " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['w-100'], " ").concat(t.pr4, " ").concat(t.pl4, " ").concat(s$8.companies) }, (companies).reduce(function (prev, company) {
        prev.push(React.createElement("li", { key: company.id, className: "".concat(s$8.list, " ").concat(s$8[company.name] ? s$8[company.name] : '') },
            React.createElement(LinkOrSpan, { target: "_blank", rel: "noopener noreferrer", href: company.link, className: "".concat(t.dib, " ").concat(t.normal, " ").concat(t['w-auto'], " ").concat(t['h-auto'], " ").concat(t['no-underline'], " ").concat(s$8.anchor) }, company.label)));
        return prev;
    }, [])));
};

function createVisitorUSACookie(urlRedirect) {
    if (typeof window !== 'undefined') {
        if (urlRedirect === 'https://www.rakuten.com') {
            document.cookie = 'visitor-usa=true; domain=.rakuten.com; path=/';
        }
    }
}
var getClassiqueHref = function () {
    var returnUrl = '/'; // for ssr, will update in browser matching the url visited
    if (typeof window !== 'undefined') {
        var urlObj = new URL(window.location.toString());
        urlObj.searchParams.set('force_version', 'classic');
        returnUrl = urlObj.toString();
    }
    return returnUrl;
};

var s$7 = {"container":"_f-container-ad7b1a","select":"_f-select-b392e8"};

var onClickForRedirectionUSA$1 = function onClickForRedirectionUSA(event) {
    event.preventDefault();
    if (event.target.value === 'https://www.rakuten.com') {
        createVisitorUSACookie(event.target.value);
    }
    return window.location.assign(event.target.value);
};
var RakutenGroupLinksSelect = function (_a) {
    var select = _a.select;
    return (React.createElement("div", { className: "".concat(t.relative, " ").concat(t.pointer, " ").concat(s$7.container) },
        React.createElement("select", { className: "".concat(t['bg-white'], " ").concat(t.pointer, " ").concat(s$7.select), onChange: onClickForRedirectionUSA$1 }, (select).reduce(function (prev, country) {
            prev.push(React.createElement("option", { key: country.id, value: country.link }, country.label));
            return prev;
        }, []))));
};

var s$6 = {"container":"_f-container-34d1c1"};

var RakutenGroupLinks = function (_a) {
    var rakutenLogo = _a.rakutenLogo, companies = _a.companies, select = _a.select;
    return (React.createElement("div", { className: "".concat(t.flex, " ").concat(t['justify-between'], " ").concat(t['items-center'], " ").concat(t.pr4, " ").concat(t.pl4, " ").concat(t['bg-white'], " ").concat(s$6.container) },
        React.createElement(RakutenGroupLinksLogo, { rakutenLogo: rakutenLogo }),
        React.createElement(RakutenGroupLinksCompanies, { companies: companies }),
        React.createElement(RakutenGroupLinksSelect, { select: select })));
};

var corporate = [
	"/publicite/"
];
var NoFollows = {
	corporate: corporate
};

var s$5 = {"groupedLinksLabel":"_f-groupedLinksLabel-dc7beb","linkItem":"_f-linkItem-d2cddb","icon":"_f-icon-c24322","iconed":"_f-iconed-7c31c0","linkIcon":"_f-linkIcon-cdbb84","collapse":"_f-collapse-737fab","pmCorpGroupList":"_f-pmCorpGroupList-0b9319","slideUp":"_f-slideUp-ebfe86","slideDown":"_f-slideDown-fb346c"};

var noFollows = NoFollows.corporate;
var CorporateBlocks = /** @class */ (function (_super) {
    __extends(CorporateBlocks, _super);
    function CorporateBlocks(props) {
        var _this = _super.call(this, props) || this;
        _this.renderLink = function (item) {
            if (noFollows.includes(item.link) || item.noFollow) {
                return (React.createElement(LinkOrSpan, __assign({}, item, { href: item.link, className: "".concat(t.link, " ").concat(t['dark-gray']), rel: "nofollow" }), item.label));
            }
            return (React.createElement(LinkOrSpan, __assign({}, item, { href: item.link, className: "".concat(t.link, " ").concat(t['dark-gray']) }), item.label));
        };
        var isOpen = props.groupedLinks.isOpen ? !props.groupedLinks.isOpen : true;
        _this.state = {
            closed: isOpen,
        };
        _this.onToggle = _this.onToggle.bind(_this);
        return _this;
    }
    CorporateBlocks.prototype.onToggle = function () {
        var closed = this.state.closed;
        this.setState({ closed: !closed });
    };
    CorporateBlocks.prototype.render = function () {
        var _this = this;
        var closed = this.state.closed;
        var groupedLinks = this.props.groupedLinks;
        var slideClass = closed ? s$5.slideUp : s$5.slideDown;
        var collapsibleClass = "".concat(s$5.collapse, " ").concat(t['helper_hide-AboveTablet']);
        var collapsibleIcon = closed ? (React.createElement(FooterIcon, { iconUri: 'plus', className: collapsibleClass, width: '16', height: '16' })) : (React.createElement(FooterIcon, { iconUri: 'minus', className: collapsibleClass, width: '16', height: '16' }));
        return (React.createElement("li", { className: "".concat(t.pa0, " ").concat(t.list, " ").concat(s$5.pmCorpGroupList), "data-qa": "footer-corporate-block", onClick: this.onToggle },
            React.createElement("div", { className: "".concat(t.pa0, " ").concat(t['dark-gray'], " ").concat(s$5.groupedLinksLabel) },
                groupedLinks.icon && (React.createElement(FooterIcon, { className: "".concat(s$5.linkIcon, " ").concat(t['helper_hide-AboveTablet']), iconUri: groupedLinks.icon, width: groupedLinks.width, height: groupedLinks.height })),
                groupedLinks.label,
                collapsibleIcon),
            React.createElement("ul", { className: "".concat(t.list, " ").concat(t.pa0, " ").concat(slideClass) }, groupedLinks.links.map(function (item) { return (React.createElement("li", { key: "corporateBlocks-".concat(groupedLinks.icon, "-").concat(item.icon || item.id), "data-qa": "footer-corporate-link", className: "".concat(t['bg-near-white'], " ").concat(s$5.linkItem, " ").concat(item.icon ? s$5.iconed : '', " ").concat(item.hideOnDesktop ? t['helper_hide-AboveTablet'] : '') },
                item.icon && (React.createElement(FooterIcon, { className: "".concat(s$5.icon, " ").concat(t['helper_hide-AboveTablet']), iconUri: item.icon, width: item.width, height: item.height })),
                _this.renderLink(item))); }))));
    };
    return CorporateBlocks;
}(Component));

var s$4 = {"groupedLinksLabel":"_f-groupedLinksLabel-a4fa67","linkItem":"_f-linkItem-6d6554","pmCorpLinks":"_f-pmCorpLinks-6070b1"};

var PriceministerCorporate = function (_a) {
    var groups = _a.groups;
    return (React.createElement("ul", { className: "".concat(t.pa0, " ").concat(t.ma0, " ").concat(t['bg-near-white'], " ").concat(s$4.pmCorpLinks) }, groups.map(function (groupedLinks) { return (React.createElement(CorporateBlocks, { groupedLinks: groupedLinks, key: "priceministerCorporate-".concat(groupedLinks.icon) })); })));
};

var s$3 = {"paymentMethodsSpace":"_f-paymentMethodsSpace-7dd85a"};

/* eslint-disable react/no-array-index-key */
var PaymentMethods = function (_a) {
    var icons = _a.icons;
    return (React.createElement("div", { className: "".concat(s$3.paymentMethodsSpace, " ").concat(t.pv3, " ").concat(t.ph4, " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['bg-white']) }, icons.map(function (item, id) { return (React.createElement("div", { className: "".concat(t.pt2), key: "PaymentMethods_".concat(id) },
        React.createElement(FooterIcon, { className: "".concat(t.db, " ").concat(t['overflow-hidden']), iconUri: item.icon, height: item.height, width: item.width }),
        React.createElement("span", { className: "".concat(t['sr-only']) }, item.label))); })));
};

var s$2 = {"pmCopyright":"_f-pmCopyright-10d588","rk_Pm_Copyright":"_f-rk_Pm_Copyright-271a77"};

var s$1 = {"anchor":"_f-anchor-8573b6","links":"_f-links-aa74a7","companies":"_f-companies-1c712c","list":"_f-list-f2a669"};

var RakutenSdtLinksInline = function (_a) {
    var _b = _a.links, links = _b === void 0 ? [] : _b;
    return (React.createElement("ul", { className: "".concat(t.list, " ").concat(t.ma0, " ").concat(t.pa0, " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['w-100'], " ").concat(t.pr4, " ").concat(t.pl4, " ").concat(t.pb4, " ").concat(s$1.companies) }, links.reduce(function (prev, link) {
        prev.push(React.createElement("li", { key: link.id, className: "".concat(t.flex, " ").concat(t.pa1, " ").concat(s$1.links, " ").concat(s$1.list) },
            React.createElement("a", { target: "_self", rel: "noopener noreferrer", href: link.link, className: "".concat(t.dib, " ").concat(t.normal, " ").concat(t['w-auto'], " ").concat(t['h-auto'], " ").concat(s$1.anchor) }, link.label)));
        return prev;
    }, [])));
};

var s = {"container":"_f-container-fe2477"};

var RakutenSdtLinks = function (_a) {
    var links = _a.links;
    return (React.createElement("div", { className: "".concat(t.flex, " ").concat(t['justify-between'], " ").concat(t['items-center'], " ").concat(t.pr4, " ").concat(t.pl4, " ").concat(t['bg-white'], " ").concat(s.container) },
        React.createElement(RakutenSdtLinksInline, { links: links })));
};

var config$1 = configService.get();
var footerStatic = {
    "apps": {
        "label": "Avec l'appli Rakuten, bénéficiez de 5% remboursés en Rakuten Points sur tous vos achats !",
        "link": "/event/club-rakuten#xtatc=PUB-[PMC][HomePage][x7App][]",
        "links": [
            {
                "id": 0,
                "link": "https://app.appsflyer.com/id579373363?pid=PriceMinister&c=Page_EVT_2015",
                "label": "Application Appstore",
                "icon": "appStore",
                "width": "135",
                "height": "40",
                "os": "apple"
            },
            {
                "id": 1,
                "link": "https://app.appsflyer.com/com.priceminister.buyerapp?pid=PriceMinister&c=Page_EVT_2015",
                "label": "Application Android",
                "icon": "playStore",
                "width": "135",
                "height": "40",
                "os": "android"
            }
        ]
    },
    "corporate": {
        "groups": [
            {
                "label": "Liens utiles",
                "icon": "star",
                "width": "24",
                "height": "24",
                "isOpen": true,
                "links": [
                    {
                        "id": 0,
                        "link": "/connect?action=login&c=80",
                        "label": "Mon compte",
                        "icon": "profile",
                        "width": "24",
                        "height": "24",
                        "dataQA": "footer-account"
                    },
                    {
                        "id": 1,
                        "link": "/cart",
                        "label": "Mon panier",
                        "icon": "cart",
                        "width": "24",
                        "height": "24",
                        "dataQA": "footer-cart"
                    },
                    {
                        "id": 2,
                        "link": "https://help.fr.shopping.rakuten.net/hc/fr/articles/8285643511570-Payer-en-3-fois-avec-Klarna",
                        "label": "Paiement en plusieurs fois",
                        "icon": "creditCard",
                        "width": "24",
                        "height": "24",
                        "dataQA": "footer-payment"
                    },
                    {
                        "id": 3,
                        "link": "/v/vendre",
                        "label": "Vendre",
                        "icon": "sell",
                        "width": "24",
                        "height": "24",
                        "dataQA": "footer-sell"
                    },
                    {
                        "id": 4,
                        "link": "/connect?action=login",
                        "label": "Suivre ma commande",
                        "icon": "orderTracking",
                        "width": "24",
                        "height": "24",
                        "dataQA": "footer-tracking"
                    },
                    {
                        "id": 5,
                        "link": "/connect?action=login",
                        "label": "Mon Club R",
                        "icon": "card",
                        "width": "24",
                        "height": "24",
                        "dataQA": "footer-clubR"
                    }
                ]
            },
            {
                "label": "Aide",
                "icon": "help",
                "width": "24",
                "height": "24",
                "isOpen": false,
                "links": [{
                        "id": 0,
                        "link": "/newhelp/",
                        "label": "Besoin d'aide ?",
                        "dataQA": "footer-help"
                    },
                    {
                        "id": 1,
                        "link": config$1.featureFlipping.merchantCenterIsActive && config$1.featureFlipping.merchantOnboardingIsActive
                            ? "/merchant-center/onboarding-pro"
                            : "/seller/sell-register-pro",
                        "label": "Ouvrir un e-shop en tant que commerçant",
                        "dataQA": "footer-openShop"
                    },
                    {
                        "id": 2,
                        "link": "/newhelp/signalements/",
                        "label": "Signaler un contenu illicite"
                    },
                    {
                        "id": 3,
                        "link": "/plan-de-site/sitemap-nav",
                        "label": "Plan du site"
                    },
                    {
                        "id": 4,
                        "link": "https://global.fr.shopping.rakuten.com/actualite/",
                        "label": "Le blog"
                    }
                ]
            },
            {
                "label": "Rakuten",
                "icon": "info",
                "width": "24",
                "height": "24",
                "isOpen": false,
                "links": [
                    {
                        "id": 0,
                        "link": "https://global.fr.shopping.rakuten.com/nos-offres/",
                        "label": "Carrières"
                    },
                    {
                        "id": 1,
                        "link": "/newhelp/conditions-generales/",
                        "label": "Conditions générales"
                    },
                    {
                        "id": 2,
                        "link": "https://fr.shopping.rakuten.com/event/mentions-legales",
                        "label": "*Conditions des offres"
                    },
                    {
                        "id": 3,
                        "link": "/newhelp/vie-privee-et-cookies/",
                        "label": "Politique Vie privée"
                    },
                    {
                        "id": 4,
                        "link": "#",
                        "action": "openDidomi",
                        "label": "Gestion des cookies"
                    },
                    {
                        "id": 5,
                        "link": "/evt/affiliation-PM",
                        "label": "Affiliation"
                    },
                    {
                        "id": 6,
                        "link": "/publicite/",
                        "label": "Devenez annonceur"
                    },
                    {
                        "id": 7,
                        "link": "https://global.fr.shopping.rakuten.com/rakuten-monde/",
                        "label": "A propos de Rakuten"
                    },
                    {
                        "id": 8,
                        "link": "/newhelp/fonctionnement/",
                        "label": "Fonctionnement du service"
                    },
                    {
                        "id": 9,
                        "link": "/event/assurance",
                        "label": "Assurances"
                    }
                ]
            }
        ]
    },
    "rakutenGroup": {
        "rakutenLogo": {
            "link": "https://global.rakuten.com/",
            "img": "https://fr.shopping.rakuten.com/visuels/0_TECH/shared-svg/RakutenLogos.svg"
        },
        "companies": [
            {
                "id": 0,
                "link": "https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fwww.kobo.com%2F&D2=638.0.254426.0.32267295&C3=0b89bca361af97fbd21151cec125e851fc43e74f",
                "name": "kobo",
                "label": "Rakuten Kobo"
            },
            {
                "id": 1,
                "link": "https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Ffr.rakuten.tv%2F&D2=638.0.254426.0.32267300&C3=7569a51ff88b2c7a761d90b3517c01a362070fdb",
                "name": "tv",
                "label": "Rakuten TV"
            },
            {
                "id": 2,
                "link": "https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fwww.viber.com%2Ffr%2F&D2=638.0.254426.0.32267296&C3=5785bb59de25ef8f0d5c143aea26b265b019aee4",
                "name": "viber",
                "label": "Rakuten Viber"
            },
            {
                "id": 3,
                "link": "https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fwww.viki.com%2F&D2=638.0.254426.0.32267294&C3=8c4f956fd025fffc9af6ee87c5ee18029e98a06d",
                "name": "viki",
                "label": "Rakuten Viki"
            },
            {
                "id": 4,
                "link": "https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fglobal.rakuten.com%2Fcorp%2Fabout%2Fcompany%2F&D2=638.0.254426.0.32267305&C3=a39d9a4bd3a6fae9223f079e192d7c8874091763",
                "name": "aboutCompany",
                "label": "Plus de services"
            },
            {
                "id": 5,
                "link": "https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fglobal.rakuten.com%2Fcorp%2Fabout%2Ffr%2F&D2=638.0.254426.0.32267304&C3=c00ff816abc6bd9961d86b36399aae96331a93ca",
                "name": "aboutFr",
                "label": "À propos de Rakuten"
            }
        ],
        "select": [
            {
                "id": 0,
                "link": "https://fr.shopping.rakuten.com",
                "label": "France"
            },
            {
                "id": 1,
                "link": "https://www.rakuten.de",
                "label": "Allemagne"
            },
            {
                "id": 2,
                "link": "https://www.rakuten.com.br",
                "label": "Brésil"
            },
            {
                "id": 3,
                "link": "https://www.rakuten.com",
                "label": "Etats-Unis"
            },
            {
                "id": 4,
                "link": "https://www.rakuten.co.jp",
                "label": "Japon"
            },
            {
                "id": 5,
                "link": "https://www.rakuten.com.tw",
                "label": "Taïwan"
            }
        ]
    },
    "reinsurance": {
        "links": [
            {
                "id": 0,
                "link": "/newhelp/a-quoi-correspondent-les-etats-des-articles/",
                "labels": {
                    "small": "Le choix",
                    "large": "Neuf et occasion"
                },
                "icon": "bag",
                "width": "43",
                "height": "43"
            },
            {
                "id": 1,
                "link": "/event/club-rakuten",
                "labels": {
                    "small": "Minimum",
                    "large": "5% remboursés"
                },
                "icon": "card",
                "width": "80",
                "height": "43"
            },
            {
                "id": 2,
                "link": "/newhelp/comment-acheter/garanties-acheteur/",
                "labels": {
                    "small": "La sécurité",
                    "large": "Satisfait ou remboursé"
                },
                "icon": "shield",
                "width": "43",
                "height": "43"
            },
            {
                "id": 3,
                "link": "/newhelp/",
                "labels": {
                    "small": "Le service clients",
                    "large": "À votre écoute"
                },
                "icon": "customerCare",
                "width": "43",
                "height": "43"
            }
        ]
    },
    "social": {
        "links": [
            {
                "id": 0,
                "link": "https://www.linkedin.com/company/rakutenfrance",
                "label": "Linkedin",
                "icon": "linkedin",
                "width": "34",
                "height": "34"
            },
            {
                "id": 1,
                "link": "https://www.facebook.com/RakutenFrance",
                "label": "Facebook",
                "icon": "facebook",
                "width": "34",
                "height": "34"
            },
            {
                "id": 2,
                "link": "https://twitter.com/RakutenFrance",
                "label": "Twitter",
                "icon": "twitter",
                "width": "34",
                "height": "34"
            },
            {
                "id": 3,
                "link": "https://www.instagram.com/rakutenfrance",
                "label": "Instagram",
                "icon": "instagram",
                "width": "34",
                "height": "34"
            },
            {
                "id": 4,
                "link": "https://www.youtube.com/c/rakutenfrance",
                "label": "Youtube",
                "icon": "youtube",
                "width": "34",
                "height": "34"
            },
            {
                "id": 5,
                "link": "https://www.pinterest.com/rakutenfrance",
                "label": "Pinterest",
                "icon": "pinterest",
                "width": "34",
                "height": "34"
            }
        ]
    },
    "payment": {
        "icons": [
            {
                "id": 0,
                "label": "visa",
                "icon": "visa",
                "width": "45",
                "height": "25"
            },
            {
                "id": 1,
                "label": "mastercard",
                "icon": "mastercard",
                "width": "34",
                "height": "34"
            },
            {
                "id": 2,
                "label": "klarna",
                "icon": "klarna",
                "width": "54",
                "height": "30"
            },
            {
                "id": 3,
                "label": "paypal",
                "icon": "paypal",
                "width": "60",
                "height": "34"
            },
            {
                "id": 4,
                "label": "floa",
                "icon": "floa",
                "width": "73",
                "height": "25"
            },
            {
                "id": 5,
                "label": "americanexpress",
                "icon": "americanexpress",
                "width": "34",
                "height": "34"
            },
        ]
    }
};

var _a;
var config = configService.get();
var NAME = 'footer';
var DEFAULT_STATE = {
    visible: true,
    featureFlipping: {
        sellHomeRedirection: {
            isActive: (_a = config.featureFlipping.sellHomeRedirectionIsActive) !== null && _a !== void 0 ? _a : false,
        },
    },
};
var SELL_HOME = {
    link: '/seller/sell-form',
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NAME: NAME,
  DEFAULT_STATE: DEFAULT_STATE,
  SELL_HOME: SELL_HOME
});

var onClickForRedirectionUSA = function () {
    createVisitorUSACookie('https://www.rakuten.com');
    window.location.assign('https://www.rakuten.com');
};
var updateCorporateGroups = function (corporate, groupeIndex, values) {
    var _a;
    if (Array.isArray(corporate) && corporate.length > 0) {
        var groups = corporate[groupeIndex];
        if (groups) {
            groups = __assign(__assign({}, groups), { links: (_a = groups.links) === null || _a === void 0 ? void 0 : _a.map(function (groupLink) {
                    if (groupLink.id === (values === null || values === void 0 ? void 0 : values.id)) {
                        return __assign(__assign({}, groupLink), values);
                    }
                    return groupLink;
                }) });
            corporate[groupeIndex] = groups;
        }
    }
    return corporate;
};
var RenderFooter = function (props) {
    var _a;
    var graphQlData = props.graphQlData, footer = props.footer;
    var featureFlipping = (footer || {}).featureFlipping;
    var copyright = "\u00A9 Rakuten France 2000 - ".concat(new Date().getFullYear());
    var _b = useState([]), logoutLink = _b[0], setLogoutLink = _b[1];
    var _c = useState([]), siteClassicLink = _c[0], setSiteClassicLink = _c[1];
    var initalPriceministerCorporateGroup = useState((featureFlipping === null || featureFlipping === void 0 ? void 0 : featureFlipping.sellHomeRedirection.isActive)
        ? updateCorporateGroups(__spreadArray([], footerStatic.corporate.groups, true), 0, { id: 3, link: SELL_HOME.link })
        : __spreadArray([], footerStatic.corporate.groups, true))[0];
    var _d = useState(initalPriceministerCorporateGroup), priceministerCorporateGroup = _d[0], setPriceministerCorporateGroup = _d[1];
    useEffect(function () {
        var _a;
        if (graphQlData === null || graphQlData === void 0 ? void 0 : graphQlData.profile) {
            var logoutUrl = '/connect?action=logout';
            if ((_a = props.md.wsParams) === null || _a === void 0 ? void 0 : _a.isMobile) {
                logoutUrl = '/security_logout_front';
            }
            setLogoutLink([
                {
                    id: 6,
                    link: logoutUrl,
                    label: 'Déconnexion',
                    icon: 'logout',
                    width: '24',
                    height: '24',
                    dataQA: 'footer-logout',
                },
            ]);
        }
    }, [props.md, graphQlData]);
    useEffect(function () {
        if (props.showClassicPageLink) {
            setSiteClassicLink([
                {
                    id: 7,
                    link: getClassiqueHref(),
                    label: 'Accéder au site classique',
                    icon: 'computer',
                    width: '24',
                    height: '24',
                    hideOnDesktop: true,
                    noFollow: true,
                    dataQA: 'footer-classicLink',
                },
            ]);
        }
    }, [props.showClassicPageLink]);
    useEffect(function () {
        setPriceministerCorporateGroup([
            __assign(__assign({}, initalPriceministerCorporateGroup[0]), { links: __spreadArray(__spreadArray(__spreadArray([], initalPriceministerCorporateGroup[0].links, true), logoutLink, true), siteClassicLink, true) }),
            initalPriceministerCorporateGroup[1],
            initalPriceministerCorporateGroup[2],
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logoutLink, siteClassicLink]);
    var links = [];
    if ((_a = graphQlData === null || graphQlData === void 0 ? void 0 : graphQlData.seoLinks) === null || _a === void 0 ? void 0 : _a.links) {
        // eslint-disable-next-line prefer-destructuring
        links = graphQlData.seoLinks.links;
    }
    var childContext = {
        displayLink: false,
    };
    return (React.createElement("footer", { className: "".concat(t['bg-near-white'], " footer"), "data-qa": "footer-root" },
        React.createElement(SvgProvider, null,
            React.createElement(LinkOrSpanContext.Provider, { value: childContext },
                React.createElement(Reinsurance, { links: footerStatic.reinsurance.links }),
                React.createElement(PriceministerCorporate, { groups: priceministerCorporateGroup }),
                React.createElement("div", { className: "".concat(t.flex, " ").concat(t['flex-wrap'], " ").concat(t.pv3, " ").concat(t['bg-white']) },
                    React.createElement(SocialLinks, { links: footerStatic.social.links }),
                    React.createElement(PaymentMethods, { icons: footerStatic.payment.icons })),
                React.createElement(AppsLinks, { links: footerStatic.apps.links, link: footerStatic.apps.link, label: footerStatic.apps.label, mobileDetect: props.md }),
                React.createElement(RakutenGroupLinks, { companies: footerStatic.rakutenGroup.companies, select: footerStatic.rakutenGroup.select, rakutenLogo: footerStatic.rakutenGroup.rakutenLogo }),
                React.createElement("div", { className: "".concat(t['dn-ns']) },
                    React.createElement(LinkOrSpan, { className: "".concat(t['pa-8'], " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['w-100'], " ").concat(t['bg-white'], " ").concat(t.link, " ").concat(t.gray, " ").concat(t.f6), rel: "nofollow", href: "#", onClick: function () { return onClickForRedirectionUSA(); } }, "Rakuten.com")),
                React.createElement("div", { className: "".concat(t['bg-white'], " ").concat(s$2.rk_Pm_Copyright) },
                    React.createElement("p", { className: "".concat(t['pa-8'], " ").concat(t.tc, " ").concat(t['bg-white'], " ").concat(t['dark-gray'], " ").concat(s$2.pmCopyright, " ").concat(t.f12) }, copyright)),
                React.createElement(RakutenSdtLinks, { links: links })))));
};
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer(props) {
        return _super.call(this, props) || this;
        // this.state = {
        //   siteClassicLink: undefined, // for ssr, will update in browser matching the url visited
        //   pushedClassicLink: false,
        // };
    }
    Footer.prototype.render = function () {
        var _a, _b;
        if (!((_b = (_a = this.props.router.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.toggleFiltersAndUniverses)) {
            return React.createElement(RenderFooter, __assign({}, this.props));
        }
        return null;
    };
    Footer.defaultProps = {
        showClassicPageLink: false,
        md: {
            userAgent: null,
        },
        router: {
            location: {
                state: {
                    toggleFiltersAndUniverses: false,
                },
            },
        },
    };
    Footer.initialFragments = {
        seoLinks: gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n      fragment FooterSeoLinks on SeoLinks {\n        links {\n          id\n          link\n          label\n        }\n      }\n    "], ["\n      fragment FooterSeoLinks on SeoLinks {\n        links {\n          id\n          link\n          label\n        }\n      }\n    "]))),
    };
    Footer.SSRFragment = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fragment FooterSSRFragment on Query {\n      seoLinks {\n        links {\n          id\n          link\n          label\n        }\n      }\n    }\n  "], ["\n    fragment FooterSSRFragment on Query {\n      seoLinks {\n        links {\n          id\n          link\n          label\n        }\n      }\n    }\n  "])));
    Footer.PersonalizeFragment = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    fragment FooterpersonalizeFragment on Query {\n      profile {\n        firstNameOrPseudo\n      }\n    }\n  "], ["\n    fragment FooterpersonalizeFragment on Query {\n      profile {\n        firstNameOrPseudo\n      }\n    }\n  "])));
    Footer.personalizedFragments = {
        profile: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      fragment FooterProfile on Profile {\n        firstNameOrPseudo\n      }\n    "], ["\n      fragment FooterProfile on Profile {\n        firstNameOrPseudo\n      }\n    "]))),
    };
    return Footer;
}(React.Component));
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4;

var mapStateToProps = function (state, ownProps) {
    var _a;
    var data = ((_a = state.footer) === null || _a === void 0 ? void 0 : _a.data) || (ownProps === null || ownProps === void 0 ? void 0 : ownProps.data);
    return {
        footer: state.footer,
        data: data,
        router: state.router,
    };
};
var SSRFallbackQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query footerSSRFallback {\n    ...FooterSSRFragment\n  }\n  ", "\n"], ["\n  query footerSSRFallback {\n    ...FooterSSRFragment\n  }\n  ", "\n"])), Footer.SSRFragment);
var FooterWithGraphQl = function (props) {
    // let data: GraphQlData | undefined;
    var _a = useBreakpoint(), md = _a.md; _a.mdMatchesBrowser;
    var _b = props.PERSONALIZED_QUERY, PERSONALIZED_QUERY = _b === void 0 ? SSRFallbackQuery : _b, _c = props.PERSONALIZED_QUERY_OPTION, PERSONALIZED_QUERY_OPTION = _c === void 0 ? { ssr: true, skip: false } : _c;
    PERSONALIZED_QUERY_OPTION.ssr = true;
    PERSONALIZED_QUERY_OPTION.skip = false;
    PERSONALIZED_QUERY_OPTION.returnPartialData = true; // prevent hydration error
    var queryResult = useQuery(PERSONALIZED_QUERY, PERSONALIZED_QUERY_OPTION);
    return React.createElement(Footer, __assign({}, props, { md: md, graphQlData: queryResult.data }));
};
var ConnectedFooter = connect(mapStateToProps)(FooterWithGraphQl);
var HideInWebviewFooter = HideInWebviewHoc(ConnectedFooter);
// @ts-expect-error missing props
var BreakpointWrappedFooter = function (props) { return (React.createElement(BreakpointProvider, null,
    React.createElement(HideInWebviewFooter, __assign({}, props)))); };
BreakpointWrappedFooter.personalizedFraments = Footer.personalizedFragments;
BreakpointWrappedFooter.initalFragments = Footer.initialFragments;
BreakpointWrappedFooter.SSRFragment = Footer.SSRFragment;
BreakpointWrappedFooter.PersonalizeFragment = Footer.PersonalizeFragment;
var FooterContainer = BreakpointWrappedFooter;
var templateObject_1;

var SHOW = 'footer/SHOW';
var HIDE = 'footer/HIDE';

function reducer(state, action) {
    if (state === void 0) { state = DEFAULT_STATE; }
    switch (action.type) {
        case SHOW:
            return __assign(__assign({}, state), { visible: true });
        case HIDE:
            return __assign(__assign({}, state), { visible: false });
        default:
            return state;
    }
}

// import { Module } from '@next-common/redux-apollo-helper';
var containers = { FooterContainer: FooterContainer };
var footerModule = { containers: containers, constants: constants, reducer: reducer };

var footerDefaultLinks = [
    {
        text: 'Besoin d’aide ?',
        href: 'https://fr.shopping.rakuten.com/newhelp/',
    },
    {
        text: 'FAQ / Contacts',
        href: 'https://fr.shopping.rakuten.com/newhelp/',
    },
    {
        text: 'Conditions générales',
        href: 'https://fr.shopping.rakuten.com/newhelp/conditions-generales/',
    },
    {
        text: 'Vie privée et cookies',
        href: 'https://fr.shopping.rakuten.com/newhelp/vie-privee-et-cookies/',
    },
];

var useStyles = makeStyles({
    footerMinimalContainer: {
        paddingTop: '2.4rem',
        borderTop: "1px solid ".concat(colorPalette.gray500),
    },
    hyperlinksContainer: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    hyperlinkWrapper: {
        display: 'flex',
    },
    hyperlink: {
        textDecoration: 'none',
        transition: 'color .15s ease-in',
        opacity: 1,
        color: colorPalette.gray800,
        display: 'block',
        '&:hover': {
            opacity: '0.5',
            transition: 'opacity .15s ease-in',
        },
        '&:active': {
            opacity: '0.8',
            transition: 'opacity .15s ease-out',
        },
        '&:focus': {
            opacity: '0.5',
            transition: 'opacity .15s ease-in',
        },
    },
    hyperlinkDash: {
        fontSize: '1.2rem',
        color: colorPalette.gray800,
        marginLeft: '0.4rem',
        marginRight: '0.4rem',
    },
    footerDateContainer: {
        width: '100%',
        marginTop: '1.6rem',
    },
    footerDate: {
        color: colorPalette.gray500,
        fontSize: '1.4rem',
        textAlign: 'center',
    },
});

var FooterMinimal = function (_a) {
    var _b = _a.links, links = _b === void 0 ? footerDefaultLinks : _b;
    var s = useStyles();
    return (React.createElement("div", { className: s.footerMinimalContainer, "data-qa": "footer-minimal" },
        React.createElement("div", { className: s.hyperlinksContainer }, links.map(function (_a, i) {
            var text = _a.text, href = _a.href;
            return (React.createElement("div", { className: s.hyperlinkWrapper, key: text },
                React.createElement(Hyperlink, { href: href, color: "gray800", fontSize: "1.2rem", extraClassName: s.hyperlink, openLinkInNewTab: true }, text),
                i < links.length - 1 && React.createElement("div", { className: s.hyperlinkDash }, " - ")));
        })),
        React.createElement("div", { className: s.footerDateContainer },
            React.createElement("p", { className: s.footerDate }, "\u00A9 RAKUTEN France SAS 2000-".concat(new Date().getFullYear())))));
};
var FooterMinimalWrapped = function (props) { return (React.createElement(BreakpointProvider, null,
    React.createElement(HideInWebview, null,
        React.createElement(FooterMinimal, __assign({}, props))))); };

export { FooterMinimalWrapped as FooterMinimal, footerModule as default };
